import {money} from '@bukalapak/toolbox-helper/number-helper';

const prakerjaGamification = {
  filters: {money},
  data() {
    return {
      eligibleCampaign: null,
    };
  },
  mounted() {
    this.getEligibleCampaign();
  },
  computed: {
    missions() {
      return this.eligibleCampaign?.missions || [];
    },
    checkPointItem() {
      const listCheckPoint = [{percentage: 0, text: 'Mulai!', used_quota: 0, quota: 0}];
      this.missions?.forEach((mission) => {
        listCheckPoint.push({
          percentage: Math.floor(((mission?.milestone?.progress || 0) / mission?.goal_threshold) * 100) || 0,
          text: mission.reward_description,
          used_quota: mission.used_quota || 0,
          quota: mission.quota || 0,
        });
      });
      return listCheckPoint;
    },
    bannerMweb() {
      return this.eligibleCampaign?.mweb_homepage_banner_url || this.$publicUrl('images/kartu-prakerja/prakerja-gamif-home-mweb.png');
    },
    bannerDweb() {
      return this.eligibleCampaign?.dweb_homepage_banner_url || this.$publicUrl('images/kartu-prakerja/prakerja-gamif-home-dweb.png');
    },
    isLoggedIn() {
      return !!window.USER?.id;
    },
  },
  methods: {
    getEligibleCampaign() {
      this.$api
        .getPrakerjaGamificationEligibleCampaign()
        .then((response) => {
          this.eligibleCampaign = response.data;
        })
        .catch(() => {
          this.eligibleCampaign = null;
        });
    },
    navigateToGamificationHomePage() {
      if (this.isLoggedIn) {
        this.$router.push({path: '/gamification'});
        return;
      }

      const {isAndroid, isWebview} = window.USER?.agent ?? {};
      const prefixHost = isAndroid || !isWebview ? window.location.origin : '';
      const encodedComebackUrl = window.encodeURIComponent(`${prefixHost}/kartu-prakerja`);
      window.location.replace(`${prefixHost}/login?comeback=${encodedComebackUrl}`);
    },
  },
};

export default prakerjaGamification;
